module.exports = __webpack_public_path__ + "img/SatelliteThumbnail.afd843a0.png";